
import XHeader from 'vux/src/components/x-header/index.vue'

import Error from '@/components/error'
import { getRequest } from '@/assets/scripts/utils'
export default {
name: 'errorPage',
props: [],
components: {
XHeader,
Error
},
data () {
return {
errorMsg: {
type: '404',
content: '登录失败 ...'
}
}
},
created () {
this.getErrorInfo()
},
mounted () {

},
methods: {
getErrorInfo () {
let error = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).status : null
if (error === '404') {
this.errorMsg.type = '400'
} else if (error === '500' || error === '501') {
this.errorMsg.type = '500'
}
},

back () {


}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/common/errorPage.vue